import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const currency = 'KES';
const moneyOpts = { maximumFractionDigits: 2 };
const formatMoney = (n) => `${currency} ${(Number(n) || 0).toLocaleString(undefined, moneyOpts)}`;

const row = ({ label, value }) => (
  <div style={{ marginBottom: 10 }}>
    <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase' }}>{label}</div>
    <div style={{ fontSize: 14, color: '#2c3e50' }}>{value || '-'}</div>
  </div>
);

/**
 * Read-only viewer for a manually-recorded payment — opened via the
 * "Manual" button on a paid row. `row` is expected to carry the
 * `payment_manual_*` fields attached by the read-side enrichment
 * (attachManualPaymentInfo / getServiceCharges).
 */
const ManualPaymentDetails = ({ row: paymentRow, amount, onClose }) => {
  if (!paymentRow) return null;

  const recordedAt = paymentRow.payment_manual_at
    ? moment(paymentRow.payment_manual_at).format('D MMMM YYYY - HH:mm')
    : null;

  return (
    <div
      role="presentation"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="presentation"
        style={{
          background: '#fff',
          width: 'min(420px, 92vw)',
          borderRadius: 6,
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
          overflow: 'hidden',
        }}
      >
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee' }}>
          <div style={{ fontWeight: 600, fontSize: 15 }}>Manual Payment Details</div>
        </div>
        <div style={{ padding: '14px 20px' }}>
          {row({ label: 'Mode of Payment', value: paymentRow.payment_manual_mode })}
          {amount != null && row({ label: 'Amount', value: formatMoney(amount) })}
          {row({
            label: 'Transaction Details',
            value: paymentRow.payment_manual_transaction_details,
          })}
          {row({ label: 'Recorded On', value: recordedAt })}
          <div style={{ marginBottom: 0 }}>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase' }}>
              Proof of Payment
            </div>
            {paymentRow.payment_manual_proof_file ? (
              <a
                href={paymentRow.payment_manual_proof_file}
                target="_blank"
                rel="noreferrer"
                style={{ fontSize: 14 }}
              >
                <i className="fa fa-file-o" style={{ marginRight: 4 }} />
                View attached file
              </a>
            ) : (
              <div style={{ fontSize: 14, color: '#2c3e50' }}>-</div>
            )}
          </div>
        </div>
        <div
          style={{
            padding: '12px 20px',
            borderTop: '1px solid #eee',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              border: '1px solid #ccc',
              background: '#fff',
              padding: '6px 16px',
              borderRadius: 4,
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

ManualPaymentDetails.propTypes = {
  row: PropTypes.objectOf(PropTypes.any),
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClose: PropTypes.func.isRequired,
};

ManualPaymentDetails.defaultProps = {
  row: null,
  amount: null,
};

export default ManualPaymentDetails;
